<template>
  <transition name="fade" mode="out-in">
    <v-card class="map-info" v-if="show" key="2">
      <v-icon small class="close" color="white" @click="$emit('closed')">close</v-icon>
      <h3 class="accent--text">{{ marker.name + ', ' + stateName(marker.state_id) }}</h3>
      <small class="d-block pb-2">{{ marker.address }}</small>
      <v-divider class="mb-2"></v-divider>
      <span>
        <b>Type:</b>
        {{ $lang(marker.type) }}
      </span>
      <br />
      <span>
        <b>Events:</b>
        {{ marker.events.length }}
        <router-link :to="'/events?s=' + marker.name" class="link" v-if="marker.events.length">View</router-link>
      </span>
      <br />
      <span>
        <b>Interventions:</b>
        {{ marker.aids.length }}
        <router-link :to="'/aids?s=' + marker.name" class="link" v-if="marker.aids.length">View</router-link>
      </span>
    </v-card>
  </transition>
</template>

<script>
import { STATE_FETCH } from '@/store/actions/state'

export default {
	name: 'MapInfo',
	props: ['marker', 'show'],
	created () {
    this.$store.dispatch(STATE_FETCH)
	},
	methods: {
		stateName (stateId) {
			return this.$store.getters.stateName(stateId)
		}
	}
}
</script>

<style scoped>
.map-info {
	background: rgba(255, 255, 255, .9);
	border-radius: 0 0 15px 0;
	line-height: 26px;
	padding: 20px;
	position: absolute;
	z-index: 1;
}

.close {
	background: #afafaf;
	border-radius: 0 0 0 8px;
	padding: 2px 2px 3px 3px;
	position: absolute;
	right: 0;
	top: 0;
}

.link {
	color: #CF142B;
	font-size: 12px;
	font-weight: 700;
	text-transform: uppercase
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .8s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}
</style>
